import FullScreenDialog from "../../../components/dialog/FullScreenDialog";
import React, { useMemo, useEffect, useCallback } from "react";
import PDFViewer from "../../../components/pdf/PDF.Viewer";
import Main from "../../../service/GateWay/Main";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import AnnotationPDF from "../../../components/other/AnnotationPDF";
import { _Enums_TypeUpload } from "../../../views/action/defaultEnums";
import { StorageEndpoint } from "../../../service/GateWay";

// const MS_OFFICE_VIEWER_URL = "https://view.officeapps.live.com/op/embed.aspx?src="
const MS_OFFICE_VIEWER_URL =
  "https://view.officeapps.live.com/op/embed.aspx?src=";
const supportedDocumentExtensions = [
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
];
const enum_type_file = {
  pdf: ["pdf"],
  word: ["doc", "docx"],
  excel: ["xls", "xlsx"],
  powerpoint: ["ppt", "pptx"],
};

// https://stackoverflow.com/questions/27957766/how-do-i-render-a-word-document-doc-docx-in-the-browser-using-javascript

function DocumentViewer({
  activeDoc,
  onClose,
  isModal,
  isEdit,
  phienHopId,
  isDefaultRender,
}) {
  const [data, setData] = useState(null);
  const [openFullScreenDialog, setOpenFullScreenDialog] = useState(false);

  const prepareFileData = useCallback(async (doc) => {
    let temp = doc && doc?.name.split(".").length - 1;
    let extension = doc?.name.split(".")[temp]?.toLowerCase();
    const uri = Main.getDocUrlByPath(doc.path);

    // For Word/Excel/PowerPoint files, fetch public URL for Office Online Viewer
    if (
      enum_type_file.word.includes(extension) ||
      enum_type_file.excel.includes(extension) ||
      enum_type_file.powerpoint.includes(extension)
    ) {
      try {
        const response = await StorageEndpoint.getUrlPublicDoc(doc.path);
        let publicUrl = response?.resultObj || response;
        // Replace content-disposition=attachment with inline for viewer compatibility
        if (typeof publicUrl === "string") {
          publicUrl = publicUrl.replace(
            /content-disposition=attachment/gi,
            "content-disposition=inline",
          );
        }
        console.log(publicUrl);
        setData({ uri, publicUrl, extension });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to fetch public URL:", error);
        setData({ uri, extension }); // Fallback to internal URL
      }
    } else {
      setData({ uri, extension });
    }
  }, []);

  useEffect(() => {
    if (activeDoc) {
      prepareFileData(activeDoc);
      !isModal && setOpenFullScreenDialog(true);
    }
    return () => {
      setOpenFullScreenDialog(false);
    };
  }, [activeDoc, isModal, prepareFileData]);

  const renderDocViewer = useMemo(() => {
    if (!data)
      return (
        <div
          className={
            "w-100 h-100 d-flex flex-column align-items-center justify-content-center"
          }
        >
          <i className={"fa-exclamation-circle text-danger fa-3x"} />
          <h3 className={"mt-3"}>Không có dữ liệu</h3>
        </div>
      );
    if (!supportedDocumentExtensions.includes(data.extension))
      return (
        <div
          className={
            "w-100 h-100 d-flex flex-column align-items-center justify-content-center"
          }
        >
          <i className={"fa-exclamation-circle text-danger fa-3x"} />
          <h3 className={"mt-3"}>Định dạng văn bản không được hỗ trợ!</h3>
          <h3>
            Bạn chỉ có thể xem được các văn bản có định dạng{" "}
            {supportedDocumentExtensions.join(", ")}
          </h3>
        </div>
      );
    const { uri, publicUrl } = data;
    // Use public URL if available for Word/Excel, otherwise fallback to hardcoded domain
    const fileUrl = publicUrl || "https://ecabinet.nextform.vn" + uri;
    // Use Microsoft Office Online viewer for Word/Excel
    const docSrc = `${MS_OFFICE_VIEWER_URL}${encodeURIComponent(fileUrl)}`;
    if (enum_type_file.pdf.includes(data.extension)) {
      return uri ? <PDFViewer fileUrl={uri} height={"100%"} /> : <></>;
    }
    return (
      <iframe
        id={"doc-iframe"}
        title={"Xem văn bản"}
        src={docSrc}
        width="100%"
        height="100%"
        frameBorder="0"
      />
    );
  }, [data]);
  if (isDefaultRender)
    return (
      <div style={{ height: "100%", overflowY: "hidden" }}>
        {renderDocViewer}
      </div>
    );

  return isModal ? (
    <Dialog
      open={activeDoc ? true : false}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          width: "95vw",
          maxWidth: "95vw",
          height: "90vh",
          maxHeight: "90vh",
          m: 1,
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 12,
          top: 12,
          color: "#ffffff",
          bgcolor: "#ef4444",
          border: "2px solid #ffffff",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
          width: 40,
          height: 40,
          zIndex: 1300,
          transition: "all 0.2s ease",
          "&:hover": {
            bgcolor: "#dc2626",
            transform: "scale(1.1)",
            boxShadow: "0 6px 16px rgba(0, 0, 0, 0.4)",
          },
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ p: 0, height: "100%", overflow: "hidden" }}>
        {isEdit && activeDoc ? (
          <AnnotationPDF
            type={_Enums_TypeUpload.CaNhan}
            phienHopId={phienHopId}
            url={activeDoc && Main.getDocUrlByPath(activeDoc.path)}
            style={{ height: "100%" }}
          />
        ) : (
          renderDocViewer
        )}
      </DialogContent>
    </Dialog>
  ) : (
    <FullScreenDialog
      open={openFullScreenDialog}
      onClose={() => {
        setOpenFullScreenDialog(false);
        // Đợi animation close hoàn tất rồi mới unmount component
        setTimeout(onClose, 300);
      }}
    >
      {renderDocViewer}
    </FullScreenDialog>
  );
}

export default React.memo(DocumentViewer);
